import { type Theme } from '@mui/material';
import { type SystemStyleObject } from '@mui/system';
import { Link } from '../Link/index.tsx';
import { Container, TextContainer } from './styled.ts';

export type DollygripLogoProps = {
  sx?: SystemStyleObject<Theme>;
};

export const DollygripLogo = ({ sx }: DollygripLogoProps) => {
  return (
    <Container sx={sx}>
      <Link sx={{ '&:focus-visible': { outline: 'none' } }} to="/">
        <TextContainer>dollygrip</TextContainer>
      </Link>
    </Container>
  );
};
